import React, { memo } from "react";
import { PartProps } from "../types";
import { useResult } from "../useData";
import { data, QuestionDatum, description } from "./data";
import Question from "./Question";
import { ResultValue, Part3ResultDatum } from "./types";
import { Pages } from "../Pages";
import { NavigationButtons } from "../components/NavigationButtons";
import { PartTitle } from "../components/PartTitle";

function Part3({ onPartFinish }: PartProps) {
  const {
    current,
    all,
    addResult,
    currentResult,
    allResults,
    next,
    totalCount,
    currentIndex,
    ...navigationProps
  } = useResult<ResultValue, QuestionDatum>(data, Pages.Part3);

  const handlePartFinish = () =>
    onPartFinish(all.map((_, index): Part3ResultDatum => allResults[index]));

  const handleResult = (result: ResultValue) => {
    addResult(result);
    next();
  };

  return (
    <>
      <PartTitle
        descriptionTranslation={description}
        part={Pages.Part3}
        finished={allResults.length}
        total={totalCount}
        currentIndex={currentIndex}
      />
      <Question
        question={current}
        onAnswer={handleResult}
        result={currentResult}
      />
      <NavigationButtons
        handlePartFinish={handlePartFinish}
        next={next}
        {...navigationProps}
      />
    </>
  );
}

export default memo(Part3);
